import Axios from 'axios';
Axios.defaults.withCredentials = true; // enable axios post cookie, default false
const client = Axios.create({
    baseURL: 'https://mypharma.suncare.care:4000/',
    json: true
});

export default client;
